import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Principal} from '../principal.service';
import {RolePermissionService} from '../rbac/role-permission.service';
import {RolePermission} from '../rbac/role-permission';

@Injectable()
export class RolePermissionGuard implements CanActivate, CanLoad {

  constructor(private principal: Principal, private service: RolePermissionService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>
    | Promise<boolean>
    | boolean {
    return this.checkPermissions(route.data['permissions']);
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkPermissions(route.data['permissions']);
  }

  checkPermissions(permissions: RolePermission[]) {
    const user = this.principal.getUser();
    if (permissions && user) {
      const roles = user._roles;
      console.log('role can activate:: permissions=%o roles=%o', permissions, roles);
      const allowedRole = this.service.hasPermissions(permissions);
      if (!allowedRole) {
        console.log('forbidden route');
      }
      return allowedRole;
    }
    return true;
  }
}
